import { DB } from "@/services/firebase/db"
import { Auth } from "@/services/firebase/auth"
import Tracking from "@/types/tracking/tracking"
import firebase from "firebase/compat"
import TimeRange from "@/types/time/timeRange"

export class TimesService {
  storeTime (trackedTime: { startingTime: number, endTime: number }, projectId: string, task: string, making: number) {
    const doc = DB.collection('trackedTimes').doc()
    return doc.set({
      createdAt: new Date(),
      trackedTime: (Object.assign({}, trackedTime)),
      projectId: projectId,
      userId: Auth.currentUser?.uid,
      task: task,
      making: making
    }).then(() => {
      return doc.id
    })
  }

  getAllForProject (projectId: string, userId?: string) {
    return DB.collection('trackedTimes')
      .where('userId', '==', userId || Auth.currentUser?.uid)
      .where('projectId', '==', projectId)
      .orderBy('trackedTime.startingTime', 'desc')
      .get()
      .then((trackedTimesQuery) => {
        return trackedTimesQuery.docs.map((doc) => {
          if (doc && doc.exists) {
            return {
              ...doc.data().trackedTime,
              projectId: doc.data().projectId,
              task: doc.data().task,
              making: doc.data().making,
              id: doc.id
            }
          }
        })
      })
  }

  getInTimeRangeForProject (projectId: string, timeRange: TimeRange, userId?: string) {
    return DB.collection('trackedTimes')
      .where('userId', '==', userId || Auth.currentUser?.uid)
      .where('projectId', '==', projectId)
      .where('trackedTime.startingTime', '>=', timeRange.start)
      .where('trackedTime.startingTime', '<=', timeRange.end)
      .orderBy('trackedTime.startingTime', 'desc')
      .get()
      .then((trackedTimesQuery) => {
        return trackedTimesQuery.docs.map((doc) => {
          if (doc && doc.exists) {
            return {
              ...doc.data().trackedTime,
              projectId: doc.data().projectId,
              task: doc.data().task,
              making: doc.data().making,
              id: doc.id
            }
          }
        })
      })
  }

  getAllTasks () {
    return DB.collection('trackedTimes')
      .where('userId', '==', Auth.currentUser?.uid)
      .get()
      .then((trackedTimesQuery) => {
        return trackedTimesQuery.docs.map((doc) => {
          if (doc && doc.exists) {
            return doc.data().task
          }
        })
      })
  }

  getTracking (trackingId: string) {
    return DB.collection('trackedTimes')
      .doc(trackingId)
      .get()
      .then((doc) => {
        if (doc.exists) {
          return new Tracking({
            id: doc.id,
            task: doc.data()!.task,
            making: doc.data()!.making,
            projectId: doc.data()!.projectId,
            endTime: doc.data()!.trackedTime.endTime,
            startingTime: doc.data()!.trackedTime.startingTime
          })
        }
      })
  }

  updateDateTime (docId: string, dateTime: number) {
    return DB.collection('trackedTimes').doc(docId).set({
      trackedTime: (Object.assign({ startingTime: dateTime })),
      userId: Auth.currentUser?.uid
    }, { merge: true })
  }

  updateEndingDateTime (docId: string, dateTime: number) {
    return DB.collection('trackedTimes').doc(docId).set({
      trackedTime: (Object.assign({ endTime: dateTime })),
      userId: Auth.currentUser?.uid
    }, { merge: true })
  }

  updateTask (docId: string, task?: string) {
    if (task === undefined) {
      return DB.collection('trackedTimes').doc(docId).update({
        task: firebase.firestore.FieldValue.delete()
      })
    } else {
      return DB.collection('trackedTimes').doc(docId).set({
        userId: Auth.currentUser?.uid,
        task: task
      }, { merge: true })
    }
  }

  updateProject (docId: string, projectId?: string) {
    if (projectId === undefined) {
      return DB.collection('trackedTimes').doc(docId).update({
        projectId: firebase.firestore.FieldValue.delete()
      })
    } else {
      return DB.collection('trackedTimes').doc(docId).set({
        userId: Auth.currentUser?.uid,
        projectId: projectId
      }, { merge: true })
    }
  }

  updateMaking (docId: string, making: number) {
    return DB.collection('trackedTimes').doc(docId).set({
      userId: Auth.currentUser?.uid,
      making: making
    }, { merge: true })
  }

  deleteTrackedTimesForProject (projectId: string) {
    return DB.collection('trackedTimes')
      .where('userId', '==', Auth.currentUser?.uid)
      .where('projectId', '==', projectId)
      .get()
      .then((trackedTimesQuery) => {
        trackedTimesQuery.forEach((doc) => {
          doc.ref.delete()
        })
      })
  }

  deleteTracking (trackingId: string) {
    return DB.collection('trackedTimes')
      .doc(trackingId).delete()
  }
}
